export const getTextContentFromMarkdown = (markdown: string): string => {
    if (!markdown) return '';

    const withoutMarkdownImages = markdown.replace(/!\[.*?\]\(.*?\)/g, '');
    const withoutHtmlTags = withoutMarkdownImages.replace(/<\/?[^>]+(>|$)/g, '');

    const textArea = document.createElement('textarea');
    textArea.innerHTML = withoutHtmlTags;

    return textArea.value || '';
};
